import styled from "styled-components";
export const Header = styled.header `
  background: white;
  border-bottom: 2px solid var(--ant-primary-color);
  padding: 0px;

  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  z-index: 999;
`;
export const HeaderRow = styled.div `
  line-height: var(--opendash-header-row-height);
  height: var(--opendash-header-row-height);
  width: 100%;

  &:not(:last-child) {
    border-bottom: 1px solid #eee;
    height: calc(var(--opendash-header-row-height) + 1px);
  }
`;
// export const HeaderDropdown = styled.div<{ right: boolean }>`
//   display: block;
//   padding: 1px;
//   background: #005493;
//   box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.5);
//   top: -6px;
//   position: relative;
//   min-width: 302px;
//   /* margin-left: -10px; */
//   ::before {
//     width: 0;
//     height: 0;
//     border-left: 5px solid transparent;
//     border-right: 5px solid transparent;
//     border-bottom: 5px solid #005493;
//     content: "";
//     position: absolute;
//     top: -5px;
//     left: ${(p) => (p.right ? "auto" : "18px")};
//     right: ${(p) => (p.right ? "18px" : "auto")};
//   }
// `;
// export const HeaderDropdownText = styled.div`
//   padding: 10px;
//   color: #fff;
// `;
// export const HeaderDropdownButton = styled.button`
//   color: #fff;
//   background: #0063ac;
//   display: block;
//   line-height: 40px;
//   min-width: 300px;
//   padding: 0 10px;
//   border: 0;
//   border-bottom: 1px solid #005493;
//   text-align: left;
//   :first {
//     border-top: 1px solid #005493;
//   }
//   :hover {
//     color: #fff;
//     background: #005493;
//   }
//   .anticon {
//     margin-right: 10px;
//   }
// `;
export const Layout = styled.section `
  display: flex;
  flex: auto;
  flex-direction: column;
  background: #f0f2f5;

  width: 100%;
  min-height: 100vh;
  padding-top: var(--opendash-header-height);
`;
export const Content = styled.main `
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction:column;
  align-self: stretch;
  flex: auto;
  min-height: 0;
`;
export const Footer = styled.footer `
  flex: 0 0 auto;
  background: #f0f2f5;
`;
export const FooterRowCopyright = styled.div `
  text-align: center;

  // height: 40px;
  line-height: 40px;

  > *,
  > a {
    font-size: 12px;
    color: darkgrey;
  }
`;
//# sourceMappingURL=data:application/json;base64,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